export { default } from "./MiniSelect";
